<template>
    <div style="width:100px" class="pt-4 pr-3">
        <v-select
        large
        v-model="currentLanguage"
        :items="locales"
        @change="changeLocale"
        single-line
        prepend-icon="mdi-web"
        ></v-select>
    </div>
</template>

<script>
    import i18n from '@/locale/i18n'
    import {mapState} from 'vuex'
    import { getSupportedLocales } from "@/locale/supported-locales.js"
    export default {
        watch:{
            app_locale (newValue) {
                this.$i18n.locale = newValue
                i18n.locale = newValue
                this.currentLanguage=newValue.toLowerCase();
            }
        },
        computed:{
            ...mapState('settings',['app_locale']),
            locales(){
                return getSupportedLocales().map((item)=>{
                    return item.code;
                })
            }
        },
        data(){
            return {
                currentLanguage:this.$i18n.locale,
            }
        },
        methods:{
            changeLocale (lang) {
                this.$store.commit('settings/SET_APP_LOCALE', lang);
                this.setLanguageInVuetify(lang);
            },
            setLanguageInVuetify(lang){
                if(lang && this.$vuetify && this.$vuetify.lang && this.$vuetify.lang.current){
                    this.$vuetify.lang.current = lang;
                }
            }
        },
        created() {
            let lang=(this.app_locale)?this.app_locale:this.$i18n.locale;
            this.$i18n.locale = lang;
            this.currentLanguage=lang;
            i18n.locale = lang;
            this.setLanguageInVuetify(lang);
        }
    }
</script>

<style lang="scss" scoped>

</style>